export default "__VITE_ASSET__DumUOkL___"